import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { AlertFeedback, AudioPlayer, DesignRow, Figure, FigureList, Image, ModalFeedback, Navigation, NavigationArrows, Page, Paragraph, Stage, Table, MathJax, TaskAnimation, TaskBlank, TaskButton, TaskCallout, TaskCarousel, TaskChordBuilder, TaskCustom, TaskDragDrop, TaskDropdownMulti, TaskExternal, TaskFreeResponse, TaskGraphSliderConfigurable, TaskImageClick, TaskLikertScale, TaskMultiChoice, TaskMultiSelect, TaskMultiSelectSubmit, TaskMusicPlayer, TaskMusicViewer, TaskPassageClick, TaskPassageReveal, TaskRank, TaskScaleBuilder, TaskSelect, TaskSlider, TaskSorting, TaskTabPanel, TaskTest, TaskTree, TaskTrueFalse, TaskVoiceBuilder, VideoPlayer } from '@bittnerdevelopmentgroup/interactive';
const e = {
  AlertFeedback,
  AudioPlayer,
  Col,
  DesignRow,
  Figure,
  FigureList,
  Image,
  MathJax,
  ModalFeedback,
  Navigation,
  NavigationArrows,
  Page,
  Paragraph,
  Row,
  Stage,
  Table,
  TaskAnimation,
  TaskBlank,
  TaskButton,
  TaskCallout,
  TaskCarousel,
  TaskChordBuilder,
  TaskCustom,
  TaskDragDrop,
  TaskDropdownMulti,
  TaskExternal,
  TaskFreeResponse,
  TaskGraphSliderConfigurable,
  TaskImageClick,
  TaskLikertScale,
  TaskMultiChoice,
  TaskMultiSelect,
  TaskMultiSelectSubmit,
  TaskMusicPlayer,
  TaskMusicViewer,
  TaskPassageClick,
  TaskPassageReveal,
  TaskRank,
  TaskScaleBuilder,
  TaskSelect,
  TaskSlider,
  TaskSorting,
  TaskTabPanel,
  TaskTest,
  TaskTree,
  TaskTrueFalse,
  TaskVoiceBuilder,
  VideoPlayer
};
export default e;